<template>
  <div class="contacts">
    <div class="contacts_item">
      <div class="contacts_icon">
        <Icon name="pin"></Icon>
      </div>
      <div>
        <div class="contacts_title">Contact us</div>
        <span href="#" class="contacts_link">
          EU, LT-02241, Lithuania,
          <br />Vilnius, V.A. Graiciuno str., 34
        </span>
      </div>
    </div>

    <div class="contacts_item">
      <div class="contacts_icon">
        <Icon name="message"></Icon>
      </div>
      <div>
        <div class="contacts_title">E-mail</div>
        <a href="mailto:info@dst.lt" class="contacts_link">info@dst.lt</a>
        <a href="mailto:info@dst.lt" class="contacts_link">sales@dst.lt</a>
      </div>
    </div>

    <div class="contacts_item">
      <div class="contacts_icon">
        <Icon name="phone"></Icon>
      </div>
      <div>
        <div class="contacts_title">Phone</div>
        <a href="tel:+37061617835" class="contacts_link contacts_link--icons">
          Phone: +370 6161 7835
          <div>
            <Icon name="telegram" size="13"></Icon>
            <Icon name="whatsapp" size="13"></Icon>
            <Icon name="viber" size="13"></Icon>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon.vue";
export default {
  name: "AppContacts",

  components: { Icon }
};
</script>

<style lang="scss" scoped>
@import "@/assets/function.scss";
@import "@/assets/breackpoints.scss";

.contacts {
  display: flex;
  justify-content: space-between;

  @media (max-width: $sm) {
    flex-direction: column;
  }

  &_item {
    display: flex;
    align-items: flex-start;
    line-height: 1;

    @media (max-width: $sm) {
      &:not(:last-of-type) {
        margin-bottom: 20px;
      }
    }

    svg {
      // @media (max-width: $sm) {
      //   width: 10px;
      //   height: 10px;
      // }
    }
  }

  &_title {
    margin-bottom: 15px;
    font-size: 18px;
    color: #ffffff;
    text-transform: uppercase;

    @media (max-width: $md) {
      font-size: 15px;
      margin-bottom: 10px;
    }

    @media (max-width: $sm) {
      font-size: 16px;
    }
  }

  &_link {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(#ffffff, 0.75);
    text-decoration: none;
    line-height: 1.5;
    transition: all 0.25s ease;

    @media (max-width: $md) {
      font-size: 12px;
    }

    @media (max-width: $sm) {
      font-size: 13px;
    }

    svg {
      margin-left: 4px;

      @media (max-width: $sm) {
        margin-left: 10px;
      }
    }
  }

  &_link--icons {
    // @media (max-width: $sm) {
    //   flex-direction: column;
    //   align-items: flex-start;
    // }
  }

  a.contacts_link {
    &:hover {
      color: rgba(#ffffff, 1);
    }
  }

  &_icon {
    margin-right: vw(25px);

    @media (max-width: $sm) {
      margin-right: 20px;
    }
  }
}
</style>
